import { NotificationType } from "./notifications.enum";
import { NotificationConfig } from "./notification.config";

// @dynamic
export abstract class Notification {
	static notificationId = 0;

	title: string;
	message: string;
	type: NotificationType;
	waitTime: number;
	id: string;

	constructor(
		type: NotificationType,
		message: string,
		title: string,
		config: NotificationConfig,
		waitTime: number
	) {
		Notification.notificationId++;
		this.title = title;
		this.message = message;
		this.type = type;
		this.id = `${type.toString()}-${Notification.notificationId}`;
		this.waitTime = waitTime;

		console.log("type : ", this.type.toString());

		let setWaitTime =
			type === NotificationType.INFO ||
			type === NotificationType.WARNING ||
			(type === NotificationType.ERROR &&
				!!config &&
				!!config.autoCloseErrors);

		setWaitTime = setWaitTime && !this.waitTime;

		console.log("set wait time : ", setWaitTime);

		if (setWaitTime) {
			if (config && config.waitTimes) {
				this.waitTime =
					config.waitTimes[type.toString()] ||
					config.waitTimes.default;
			} else {
				this.waitTime = 10;
			}
		}

		console.log("this : ", this);
	}
}

export class ErrorNotification extends Notification {
	constructor(
		msg: string,
		title: string,
		config: NotificationConfig,
		waitTime: number
	) {
		super(NotificationType.ERROR, msg, title, config, waitTime);
	}
}

export class WarningNotification extends Notification {
	constructor(
		msg: string,
		title: string,
		config: NotificationConfig,
		waitTime: number
	) {
		super(NotificationType.WARNING, msg, title, config, waitTime);
	}
}

export class InfoNotification extends Notification {
	constructor(
		msg: string,
		title: string,
		config: NotificationConfig,
		waitTime: number
	) {
		super(NotificationType.INFO, msg, title, config, waitTime);
	}
}

export class BusyNotification extends Notification {
	constructor(
		msg: string,
		title: string,
		config: NotificationConfig,
		waitTime: number
	) {
		super(NotificationType.BUSY, msg, title, config, waitTime);
	}
}

export interface Offsets {
	vertical?: number;
	horizontal?: number;
}

export type DockPosition =
	| "top-right"
	| "bottom-right"
	| "top-left"
	| "bottom-left"
	| "bottom-center"
	| "top-center";
